import React, {Component} from 'react'
import {Navbar,Nav,NavItem} from 'react-bootstrap'


class NavComponent extends Component{


	render(){
		
		return (
		 <div>
		  <Navbar>
		   <Navbar.Header>
		    <Navbar.Brand style={{float:'left',fontColor:'#61dafb'}}>
		     <a href="/"><b>Bahtah</b></a>
		    </Navbar.Brand>
		   </Navbar.Header>
		   <Nav>
		    <NavItem eventKey={1} href="/signup">Signup</NavItem>
		     <NavItem eventKey={2} href="/login">Login</NavItem>
		   </Nav>
		  </Navbar>
		 </div>
		)
	}
}

export default NavComponent
